import { SVGProps, Ref, forwardRef, memo } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <g clipPath="url(#clip0_8292_188821)">
      <path
        d="M1.097 11.7353C1.27315 13.3818 2.59738 14.706 4.24304 14.8895C6.7708 15.1712 9.22919 15.1712 11.7569 14.8895C13.4026 14.706 14.7269 13.3818 14.903 11.7353C15.033 10.5198 15.1429 9.27201 15.1429 7.99983C15.1429 6.72765 15.033 5.47982 14.903 4.26437C14.7269 2.61792 13.4026 1.29368 11.7569 1.11024C9.22919 0.828487 6.7708 0.828487 4.24304 1.11024C2.59738 1.29368 1.27315 2.61792 1.097 4.26437C0.966956 5.47982 0.857147 6.72765 0.857147 7.99983C0.857147 9.27201 0.966958 10.5198 1.097 11.7353Z"
        fill="#383838"
        stroke="white"
      />
      <path d="M10.0203 5.97949L5.97969 10.0201" stroke="white" strokeLinecap="round" />
      <path d="M10.0203 10.0201L5.97969 5.97949" stroke="white" strokeLinecap="round" />
    </g>
    <defs>
      <clipPath id="clip0_8292_188821">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const ForwardRef = forwardRef(SvgComponent);
const CloseNewCountryIcon = memo(ForwardRef);
export default CloseNewCountryIcon;
